<template>
	<div class="t-reg-event__wrap">
		<transition name="fadeRight">
			<success-cmp
				v-if="success"
				class="_white _event"
				:props="{
					title: successTitle,
					text: successText,
					btnEvent: btnEvent,
				}"
			>
			</success-cmp>
		</transition>
		<transition name="fadeRight">
			<error-cmp
				v-if="error"
				class="_white _event"
				:props="{
					title: errorTitle,
					text: errorText,
				}"
			>
			</error-cmp>
		</transition>
		<transition name="fadeRight">
			<div v-show="!success && !error" class="t-reg-event">
				<h2 class="t-reg-event__title" v-text="formInfo.title"></h2>
				<div class="t-reg-event-steps">
					<div class="t-reg-event-steps__circle">
						<svg width="66" height="66" viewBox="0 0 66 66" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path class="circle" d="M66 33C66 51.2254 51.2254 66 33 66C14.7746 66 0 51.2254 0 33C0 14.7746 14.7746 0 33 0C51.2254 0 66 14.7746 66 33ZM6.6 33C6.6 47.5803 18.4197 59.4 33 59.4C47.5803 59.4 59.4 47.5803 59.4 33C59.4 18.4197 47.5803 6.6 33 6.6C18.4197 6.6 6.6 18.4197 6.6 33Z" fill="#EDEDED"/>
							<path v-if="steps.length === 3" class="step" d="M66 33C66 38.8756 64.4313 44.6446 61.4559 49.7111C58.4805 54.7776 54.2064 58.9578 49.0751 61.82C43.9438 64.6821 38.1413 66.1223 32.2672 65.9919C26.3931 65.8614 20.6603 64.165 15.6611 61.0778L19.1289 55.4623C23.1283 57.932 27.7145 59.2891 32.4138 59.3935C37.1131 59.4979 41.755 58.3457 45.8601 56.056C49.9651 53.7663 53.3844 50.4221 55.7647 46.3689C58.145 42.3157 59.4 37.7005 59.4 33H66Z" fill="#009DD9"/>
							<path v-if="steps.length === 3" class="step _step2" :class="{_active: currentStep > 0}" d="M66 33C66 38.8756 64.4313 44.6446 61.4559 49.7111C58.4805 54.7776 54.2064 58.9578 49.0751 61.82C43.9438 64.6821 38.1413 66.1223 32.2672 65.9919C26.3931 65.8614 20.6603 64.165 15.6611 61.0778L19.1289 55.4623C23.1283 57.932 27.7145 59.2891 32.4138 59.3935C37.1131 59.4979 41.755 58.3457 45.8601 56.056C49.9651 53.7663 53.3844 50.4221 55.7647 46.3689C58.145 42.3157 59.4 37.7005 59.4 33H66Z" fill="#009DD9"/>
							<path v-if="steps.length === 3" class="step _step3" :class="{_active: currentStep === 2}" d="M66 33C66 38.8756 64.4313 44.6446 61.4559 49.7111C58.4805 54.7776 54.2064 58.9578 49.0751 61.82C43.9438 64.6821 38.1413 66.1223 32.2672 65.9919C26.3931 65.8614 20.6603 64.165 15.6611 61.0778L19.1289 55.4623C23.1283 57.932 27.7145 59.2891 32.4138 59.3935C37.1131 59.4979 41.755 58.3457 45.8601 56.056C49.9651 53.7663 53.3844 50.4221 55.7647 46.3689C58.145 42.3157 59.4 37.7005 59.4 33H66Z" fill="#009DD9"/>

							<path v-if="steps.length === 2" class="step" fill-rule="evenodd" clip-rule="evenodd" d="M9.71093 56.3818C15.6789 62.3256 23.9092 65.9995 32.9976 65.9995C51.223 65.9995 65.9976 51.2249 65.9976 32.9995C65.9976 23.9112 62.3236 15.6809 56.3799 9.71289L51.713 14.3798C56.4624 19.1534 59.3976 25.7337 59.3976 32.9995C59.3976 47.5799 47.5779 59.3996 32.9976 59.3996C25.7318 59.3996 19.1515 56.4643 14.3778 51.7149L9.71093 56.3818Z" fill="#B3E8D4"/>
							<path v-if="steps.length === 2" class="step _step22" :class="{_active: currentStep > 0}" fill-rule="evenodd" clip-rule="evenodd" d="M9.71093 56.3818C15.6789 62.3256 23.9092 65.9995 32.9976 65.9995C51.223 65.9995 65.9976 51.2249 65.9976 32.9995C65.9976 23.9112 62.3236 15.6809 56.3799 9.71289L51.713 14.3798C56.4624 19.1534 59.3976 25.7337 59.3976 32.9995C59.3976 47.5799 47.5779 59.3996 32.9976 59.3996C25.7318 59.3996 19.1515 56.4643 14.3778 51.7149L9.71093 56.3818Z" fill="#B3E8D4"/>
						</svg>
						<div class="t-reg-event-steps__numbers">
							{{ currentStep + 1 }}/{{ steps.length }}
						</div>
					</div>
					<div class="t-reg-event-steps__container">
						<h4 class="t-reg-event-steps__title">{{ steps[currentStep].title }}</h4>
						<div class="t-reg-event-steps__then">
							{{ steps[currentStep].description }}
						</div>
					</div>
				</div>
				<form
					class="t-form t-reg-event-form"
					:class="{_disabled: disabledForm, _white: white}"
					@submit.stop.prevent="submitRegEvent"
				>
					<transition-group
						:name="currentStep < currentStepOld ? 'fadeLeft' : 'fadeRight'"
					>
						<div
							class="t-reg-ecent-form__step-layout"
							:key="'step' + currentStep"
						>
							<div class="t-reg-event-form__container">
								<div
									class="t-form__item"
									:class="{
										_half: item.type === 'textarea' ||
										item.type === 'dropzone' ||
										item.type === 'images',
										_hidden: item.type === 'view-hidden'
									}"
									v-for="(item, index) in currentForm"
								>
									<div v-if="item.title" class="t-form__label">
										{{ item.title }}
										<span v-if="item.requiredField">*</span>
									</div>

									<input
										v-if="item.type === 'view-hidden'"
										type="hidden"
										:value="item.defaultValue"
									/>
	
									<select-custom-cmp
										class="_white"
										v-if="item.type === 'select'"
										:data="item"
										:multi="item.typeField === 8"
										ref="selectCustom"
									>
									</select-custom-cmp>
	
									<input
										v-if="item.type === 'text'"
										class="t-input"
										:class="{'_error': item.error, '_valid': item.valid}"
										:type="item.type"
										:placeholder="item.hintField"
										v-model="item.value"
										@focus="focusRegEvent(index)"
									/>
	
									<input
										v-if="item.type === 'number'"
										class="t-input"
										:class="{ _error: item.error, _valid: item.valid }"
										type="text"
										:placeholder="item.hintField"
										v-model="item.value"
										@keydown="keydownNumber($event)"
										@input="deleteChar(item)"
										@focus="focusRegEvent(index)"
									/>
	
									<masked-input
										v-if="item.type === 'phone'"
										class="t-input"
										:class="{ _error: item.error, _valid: item.valid }"
										mask="\+\7(111)111-11-11"
										:placeholder="item.hintField"
										v-model="item.value"
										@input="focusRegEvent(index)"
										:ref="index"
									/>
	
									<textarea
										v-if="item.type === 'textarea'"
										:class="{ _error: item.error, _valid: item.valid }"
										class="t-textarea _108"
										:placeholder="item.hintField"
										v-model="item.value"
										@focus="focusRegEvent(index)"
									>
									</textarea>
	
									<div v-if="item.type === 'radio'" class="t-form__radio _green">
										<template v-for="(radio, idxRadio) in item.list">
											<input
												v-if="idxRadio === 0"
												checked
												:id="item.id.toString() + idxRadio"
												:name="item.id"
												class="t-radio"
												:value="radio.id"
												@change="changeRadio(index, $event)"
												:type="item.type"
											/>
											<input
												v-else
												:id="item.id.toString() + idxRadio"
												:name="item.id"
												class="t-radio"
												:value="radio.id"
												@change="changeRadio(index, $event)"
												:type="item.type"
											/>
	
											<label :for="item.id.toString() + idxRadio" class="t-radio__text">
												{{ radio.label }}
											</label>
										</template>
									</div>
	
									<input
										v-if="item.type === 'date-picker'"
										class="t-input _date-picker"
										:class="{'_error': item.error, '_valid': item.valid}"
										:type="item.type"
										:placeholder="item.hintField"
										:value="formatDate(item.value)"
										@focus="focusForm(index)"
										@click="setVisibleDatePicker(index)"
										readonly
									/>
									<transition name="fade">
										<div
											v-if="item.type === 'date-picker' && visibleDatePicker === index"
											class="t-filter__date-picker"
											@click.stop=""
										>
											<v-date-picker
												v-model="item.value"
												:first-day-of-week="1"
												@input="visibleDatePicker = -1"
												:locale="$router.history.base !== '' ? $router.history.base.substring(1) : 'ru'"
												no-title
											>
											</v-date-picker>
										</div>
									</transition>
	
									<div
										v-if="item.type === 'date-picker'"
										class="t-input__calendar"
									>
										<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path d="M6.88889 6.11111V3V6.11111ZM13.1111 6.11111V3V6.11111ZM6.11111 9.22222H13.8889H6.11111ZM4.55556 17H15.4444C15.857 17 16.2527 16.8361 16.5444 16.5444C16.8361 16.2527 17 15.857 17 15.4444V6.11111C17 5.69855 16.8361 5.30289 16.5444 5.01117C16.2527 4.71944 15.857 4.55556 15.4444 4.55556H4.55556C4.143 4.55556 3.74733 4.71944 3.45561 5.01117C3.16389 5.30289 3 5.69855 3 6.11111V15.4444C3 15.857 3.16389 16.2527 3.45561 16.5444C3.74733 16.8361 4.143 17 4.55556 17Z" stroke="#00b0bd" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
										</svg>
									</div>
	
									<div
										v-if="item.type === 'checkbox'"
										class="t-form__checkbox"
										:class="{'_error': item.error}"
										v-for="(checkbox, idxCheckbox) in item.list"
									>
										<input
											:checked="checkbox.checked"
											:id="checkbox.id + idxCheckbox"
											:name="checkbox.id"
											class="t-checkbox"
											:type="item.type"
											@change="checkbox.checked = !checkbox.checked; item.error = false;"
										>
										<label :for="checkbox.id + idxCheckbox" class="t-checkbox__text">{{ checkbox.label }}</label>
										<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path fill-rule="evenodd" clip-rule="evenodd" d="M16.7064 5.29279C16.8939 5.48031 16.9992 5.73462 16.9992 5.99979C16.9992 6.26495 16.8939 6.51926 16.7064 6.70679L8.70643 14.7068C8.5189 14.8943 8.2646 14.9996 7.99943 14.9996C7.73427 14.9996 7.47996 14.8943 7.29243 14.7068L3.29243 10.7068C3.11027 10.5182 3.00948 10.2656 3.01176 10.0034C3.01403 9.74119 3.1192 9.49038 3.30461 9.30497C3.49002 9.11956 3.74083 9.01439 4.00303 9.01211C4.26523 9.00983 4.51783 9.11063 4.70643 9.29279L7.99943 12.5858L15.2924 5.29279C15.48 5.10532 15.7343 5 15.9994 5C16.2646 5 16.5189 5.10532 16.7064 5.29279Z" fill="#00b0bd"/>
										</svg>
									</div>
	
									<div v-if="item.type === 'images'" class="t-form-images">
										<div
											class="t-form__checkbox t-form-images__item"
											v-for="(images, idxImages) in item.list"
										>
											<div class="t-form-images__img">
												<img :src="images.image" alt="">
												<input
													:checked="images.checked"
													:id="images.id + idxImages"
													:name="images.id"
													class="t-checkbox"
													type="checkbox"
													@change="images.checked = !images.checked"
												>
												<label :for="images.id + idxImages" class="t-checkbox__text"></label>
												<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
													<path fill-rule="evenodd" clip-rule="evenodd" d="M16.7064 5.29279C16.8939 5.48031 16.9992 5.73462 16.9992 5.99979C16.9992 6.26495 16.8939 6.51926 16.7064 6.70679L8.70643 14.7068C8.5189 14.8943 8.2646 14.9996 7.99943 14.9996C7.73427 14.9996 7.47996 14.8943 7.29243 14.7068L3.29243 10.7068C3.11027 10.5182 3.00948 10.2656 3.01176 10.0034C3.01403 9.74119 3.1192 9.49038 3.30461 9.30497C3.49002 9.11956 3.74083 9.01439 4.00303 9.01211C4.26523 9.00983 4.51783 9.11063 4.70643 9.29279L7.99943 12.5858L15.2924 5.29279C15.48 5.10532 15.7343 5 15.9994 5C16.2646 5 16.5189 5.10532 16.7064 5.29279Z" fill="#00b0bd"/>
												</svg>
											</div>
											<div class="t-form-images__text">{{ images.label }}</div>
										</div>
									</div>
	
									<vue-dropzone
										v-if="item.type === 'dropzone'"
										id="dropzone"
										class="_dynamic _white"
										:class="{ _error: item.error, _valid: item.valid }"
										ref="dropzone"
										:options="dropzoneOptions"
										:useCustomSlot="true"
									>
										<div class="dropzone-custom-title">
											{{ item.hintField }}
										</div>
									</vue-dropzone>
	
									<ui-dadata-organisation-autocomplete
										v-if="item.type === 'dadata-organisation'"
										:placeholder="item.hintField"
										:value="item.value"
										@update:value="v => item.value = v"
										:error="item.error"
										:valid="item.valid"
										:disabled="!isUserAuth && !location"
										:location="location || null"
										@focus="focusRegEvent(index)"
									/>
	
									<ui-dadata-city-autocomplete
										v-if="item.type === 'dadata-city'"
										:placeholder="item.hintField"
										:value="item.value"
										@update:value="v => {
											item.value = v
											location = v
										}"
										:error="item.error"
										:valid="item.valid"
										@focus="focusRegEvent(index)"
									/>
	
									<svg class="t-form__error-svg" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M1 1L9 9" stroke="white" stroke-width="2"/>
										<path d="M9 1L1 9" stroke="white" stroke-width="2"/>
									</svg>
								</div>
	
								<div
									v-if="!$route.fullPath.includes('/lk') && currentStep === forms.length - 1"
									class="t-personal-data t-reg-event-form__personal"
									:class="{_error: errorPersonalData}"
								>
									<input
										@change="changePersonalData()"
										type="checkbox"
										:id="'personal-data-feedback' + formInfo.id"
										class="t-personal-data__input"
									/>
									<label :for="'personal-data-feedback' + formInfo.id">
										<svg width="16" height="12" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path fill-rule="evenodd" clip-rule="evenodd" d="M10.4213 0.944336L11.3327 1.63582L4.82917 7.88078C4.71347 7.99188 4.54763 8.05545 4.37347 8.05545C4.19932 8.05545 4.03347 7.99188 3.91777 7.88078L0.666016 4.7583L1.57741 4.06681L4.37347 6.75171L10.4213 0.944336Z" fill="white"/>
										</svg>
										{{$root.staticText.forms.agree}}
										<span class="t-personal-data__link" @click.stop.prevent="clickToPage">
											{{$root.staticText.forms.personalData}}
										</span>
									</label>
								</div>
							</div>

							<div class="t-reg-event-form__row">
								<div v-if="currentStep > 0" @click="backStep" class="t-btn t-reg-event-form__btn" :class="{_border: white, _back: !white}">
									{{ $root.staticText.forms.back }}
								</div>
								<button class="t-btn _green t-reg-event-form__btn" :class="{_white: white, _border: white}">
									<template v-if="steps.length - 1 === currentStep">
										{{ $root.staticText.forms.regBtn }}
									</template>
									<template v-else>
										{{ $root.staticText.forms.then }}
									</template>
								</button>
							</div>
						</div>

					</transition-group>

					<vue-recaptcha
						ref="recaptcha"
						size="invisible"
						:sitekey="$root.sitekeyRecaptcha"
						:load-recaptcha-script="true"
						@verify="onCapchaRegister"
						@expired="onCaptchaExpired"
						@error="errorCaptcha"
					/>
				</form>
			</div>
		</transition>
	</div>
</template>

<script>
	import {mapActions, mapGetters} from "vuex";
	import success from "@components/base/modals/success";
	import error from "@components/base/modals/error";
	import selectCustom from '@components/ui-components/select-custom/select-custom-dynamic.vue';
	import vue2Dropzone from 'vue2-dropzone';
	import VueRecaptcha from 'vue-recaptcha';
	import UIDadataOrganisationAutocomplete from '@components/ui-components/dadata-autocomplete/dadata-organisation-autocomplete.vue';
	import UIDadataCityAutocomplete from '@components/ui-components/dadata-autocomplete/dadata-city-autocomplete.vue';
	import { formMixin as formWithStepsMixin } from "../mixins/form-steps";

	export default {
		name: "regEvent",
		mixins: [ formWithStepsMixin ],
		props: {
			idEvent: String,
			white: Boolean,
			formInfo: {
				type: Object,
			},
			successTitle: {
				type: String,
				default: window.staticText.modal.successTitle
			},
			successText: {
				type: String,
				default: window.staticText.modal.successText2
			},
			errorTitle: {
				type: String,
				default:window.staticText.modal.errorTitle
			},
			errorText: {
				type: String,
				default: window.staticText.modal.errorText
			},
			btnEvent: {
				type: String,
				default: ''
			},
			// btnCalendar: {
			//     type: String,
			//     default: ''
			// }
		},
		data: () => ({
			action: "feedback/send",
			visibleDatePicker: -1,
		}),
		components: {
			'success-cmp': success,
			'error-cmp': error,
			vueDropzone: vue2Dropzone,
			VueRecaptcha,
			'select-custom-cmp': selectCustom,
			'ui-dadata-organisation-autocomplete': UIDadataOrganisationAutocomplete,
			'ui-dadata-city-autocomplete': UIDadataCityAutocomplete,
		},
		computed: {
			...mapGetters('lk', ['isAuth']),
		},
		methods: {
			...mapActions('modal', {
				closeModal: 'closeModal'
			}),
			...mapActions({
				getDadata: 'getDadata'
			}),
			setVisibleDatePicker (index) {
				this.visibleDatePicker = this.visibleDatePicker === index ? -1 : index;
			},
			clickToPage () {
				if (this.$route.name === 'UserAgreement') {
					this.modalClose();
					return;
				}

				window.open(
					`${window.location.protocol}//${window.location.host}${this.$router.history.base}/user-agreement`,
					'_blank'
				);
			},
		}
	}
</script>

<style lang="sass">

</style>


// WEBPACK FOOTER //
// src/templates/components/base/form-steps.vue